import React from 'react';
import { Platform } from 'react-native';
import * as SVG from 'react-native-svg';
import {
  Path as PathWeb,
  Svg as SvgWeb,
} from 'react-native-svg/src/ReactNativeSVG.web';

const { Svg, Path } = SVG;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SvgComp = ({ hoverState, cssSize, ...rest }: any) =>
  Platform.OS === 'web' ? <SvgWeb {...rest} /> : <Svg {...rest} />;

export const PathComp = (props: any) =>
  Platform.OS === 'web' ? <PathWeb {...props} /> : <Path {...props} />;
